import { ColumnResizingContextProvider } from 'src/contexts/ColumnResizingContext/ColumnResizingContext';
import { Content } from 'src/contexts/ContentContext';
import { NoData, Table } from 'src/tables/Table';
import { ContentId } from 'src/utils/constants/contentId';
import { UserSetting } from 'src/WebApiController';

import { ReportTableV2Props } from '../ReportTableCommon/ReportTableCommon.types';
import { useReportDetailsTableV2 } from '../ReportTableCommon/useReportDetailsTableV2';
import {
  PurchaseReportTableColumnDefContextV2,
  usePurchaseReportTableColumnDefV2,
} from './PurchaseReportTableColumnDefContextV2';

export const PurchaseReportTableV2 = ({
  report,
  reportValueTypes,
  ...rest
}: ReportTableV2Props) => {
  return (
    <PurchaseReportTableColumnDefContextV2
      report={report}
      reportValueTypes={reportValueTypes}
    >
      <ReportTableInternal report={report} {...rest} />
    </PurchaseReportTableColumnDefContextV2>
  );
};

const ReportTableInternal = (props: ReportTableV2Props) => {
  const { displayedColumnsConfig = [] } = usePurchaseReportTableColumnDefV2();

  const { isReportConfigEmpty, tableProps, data } = useReportDetailsTableV2({
    ...props,
    displayedColumnsConfig,
  });

  return isReportConfigEmpty ? (
    <></>
  ) : data?.length > 0 ? (
    <ColumnResizingContextProvider
      userSettingId={UserSetting.ReportV2PurchaseColumnWidths}
    >
      <Table {...tableProps} />
    </ColumnResizingContextProvider>
  ) : (
    <NoData>
      <Content id={ContentId.NoReportText} />
    </NoData>
  );
};

export default PurchaseReportTableV2;
